import { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import { ChartColors } from 'theme/tokens';

import DATASET_TREND_BUTTON from '../constants';
import useSeries from './useSeries';

const useOptions = ({ metric }: { metric: MetricInput }) => {
  const {
    series,
    categories,
    interval,
    isLoading: isLoadingSeries,
  } = useSeries({
    metric,
  });
  const [options, setOptions] = useState<Highcharts.Options>({ series });

  useEffect(() => {
    setOptions({
      colors: ChartColors,
      series,
      accessibility: {
        enabled: false,
      },
      chart: {
        marginTop: 16,
        type: 'line',
        backgroundColor: 'transparent',
        height: DATASET_TREND_BUTTON.TREND_HEIGHT,
      },
      legend: {
        enabled: false,
      },
      xAxis: {
        categories,
        title: {
          text: undefined,
        },
        crosshair: {
          color: 'var(--color-grey-4)',
          width: 2,
        },
        tickColor: 'var(--color-grey-8)',
        lineColor: 'var(--color-grey-8)',
        tickInterval: 1,
        labels: {
          style: {
            color: 'var(--color-grey-7)',
          },
        },
      },
      yAxis: {
        gridLineColor: 'var(--color-grey-8)',
        title: {
          text: undefined,
        },
        allowDecimals: false,
        labels: {
          reserveSpace: false,
          align: 'left',
          x: 1,
          y: -4,
          style: {
            color: 'var(--color-grey-7)',
          },
        },
      },
      plotOptions: {
        series: {
          marker: {
            animation: false,
          },
        },
      },
      credits: {
        enabled: false,
      },
      title: {
        text: undefined,
      },
      tooltip: {
        shared: false,
        shadow: false,
        borderRadius: 8,
        padding: 0,
        outside: true,
        split: false,
        borderWidth: 0,
        backgroundColor: 'transparent',
      },
    });
  }, [categories, series]);

  return { options, isLoading: isLoadingSeries, interval };
};

export default useOptions;
